import { h, Fragment, Component} from "preact";
import {useEffect, useState, useRef} from "preact/hooks";
import HighlightEditor from "../../highlight-editor";

const DOTS = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKKADAAQAAAABAAAAKAAAAAB65masAAACuklEQVRYCe2YzWsTURDAZzYJETUiVkH0ohc/QG0xIt70L1AvGhXcasQY6E3QWyXozYLgYUMJGumCYkDEi/ccRU0hoIhe6sEWwXqxKpSmO85rJaS7yXvZzJb2kIXAezPzZn47uzP7XgD6Vz8Da5sBjCL8RTs37AFmCWiQHc6wz2oSEqOu6/yU+hcDZuzcUyK4FABB/I4QP1lxnS8BXQiBFcI2YKoy1xZOWRLtBGhMFAoFUQzRYvVYA9QtAiI68Xnqx8EWUeihCFC9c6aIRAtGG50PEeD/gtD5B7AsVTQ9XyJAjlrVRkaY22htqWltDEoRoGolwNXaKQZn+Ga5fH+uk74buQhQ9TnVShDxzYpgnDlEuF5xS49WyHuYiPugiqlaiarWpYLgd049VmnmeriXtVkSSQYvXMnv8QjOI3mDBDhjIVWfT5ReR3FLYsDM8A2bPHD407G5FYgdvxpIxS8Xi8XfrfKwY1GRZK7mjjLcYz+cgiCAs7N/FsfCAvntRYCwiHcYJe532px7lLft/O7mvIeBCJC/tcdNMeeBjplsdHoRoM5xVDoRIDfotyaQJOB7k41OLwKEGN0FwEbHABaOu+74dEd9FwoRYOVJaRItuMaQgVai2sz2TbFbXTBoTcR9UHlfzUatpV8PykgyuJqbBTFgxh7Zpw5H6vzRzLjabvFeMIrtVqzptIeBbY8MNKDxjk9wB3zLkzw/fWgoPf2xXpv06UJNRVU8Dwv3lo+X7WPy9/hBNns71V7bnVQEyCFOacMQpP56v9JaG4NSBMgZ2mXwD+B5ZhuNExEgAtY1vpdUiAmjjc6HCNACKuucq8PU/r07PulsTDpRFX+o1+pcqdxm4HAg0PKfR2ech2OzAV0IgQhQxeE28vLIUPorn4+3AcJWPm5O8e/FBkice+Y630Kw9E37GViXGfgHSoLOiEraZowAAAAASUVORK5CYII=";
const MARKERS = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTYwcHgiIGhlaWdodD0iMTNweCIgdmlld0JveD0iMCAwIDE2MCAxMyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT5BcnRib2FyZDwvdGl0bGU+CiAgICA8ZGVmcz4KICAgICAgICA8ZmlsdGVyIGlkPSJmaWx0ZXItMSI+CiAgICAgICAgICAgIDxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VHcmFwaGljIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwLjM5NzcyMiAwIDAgMCAwIDAuMDAwMDAwIDAgMCAwIDAgMC43MjYyNzUgMCAwIDAgMS4wMDAwMDAgMCI+PC9mZUNvbG9yTWF0cml4PgogICAgICAgIDwvZmlsdGVyPgogICAgICAgIDxmaWx0ZXIgaWQ9ImZpbHRlci0yIj4KICAgICAgICAgICAgPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUdyYXBoaWMiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAuMDAwMDAwIDAgMCAwIDAgMC4yODAxMzggMCAwIDAgMCAwLjQ2NDY5OSAwIDAgMCAxLjAwMDAwMCAwIj48L2ZlQ29sb3JNYXRyaXg+CiAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgPGZpbHRlciBpZD0iZmlsdGVyLTMiPgogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMC4wMDAwMDAgMCAwIDAgMCAwLjQwODUzOCAwIDAgMCAwIDAuMTg3MTE3IDAgMCAwIDEuMDAwMDAwIDAiPjwvZmVDb2xvck1hdHJpeD4KICAgICAgICA8L2ZpbHRlcj4KICAgICAgICA8ZmlsdGVyIGlkPSJmaWx0ZXItNCI+CiAgICAgICAgICAgIDxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VHcmFwaGljIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwLjQ5NzM5MSAwIDAgMCAwIDAuMzUxMTAwIDAgMCAwIDAgMC4wMDAwMDAgMCAwIDAgMS4wMDAwMDAgMCI+PC9mZUNvbG9yTWF0cml4PgogICAgICAgIDwvZmlsdGVyPgogICAgICAgIDxmaWx0ZXIgaWQ9ImZpbHRlci01Ij4KICAgICAgICAgICAgPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUdyYXBoaWMiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAuNjI2MDM3IDAgMCAwIDAgMC4wODc2ODMgMCAwIDAgMCAwLjAyODY4NiAwIDAgMCAxLjAwMDAwMCAwIj48L2ZlQ29sb3JNYXRyaXg+CiAgICAgICAgPC9maWx0ZXI+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGZpbHRlcj0idXJsKCNmaWx0ZXItMSkiIGlkPSJHcm91cCI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikljb24tLy1DaGVjayIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuMDAwMDAwLCAwLjAwMDAwMCkiIGZpbGw9IiM0MjRBNTMiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTcuNzI0OTg5MzIsNy4xNTM1MTkyNiBMMTEuMDQ0MzAyMSwzLjI2NTY0NjMgQzExLjQxODkyMzUsMi44NDEwMzMzNiAxMS4zOTg4MDExLDIuMTk4NjM5ODcgMTAuOTk4NDExNCwxLjc5ODI1MDIgTDkuNzY0MDM1NTIsMC41NjM4OTM0MDQgQzkuMzYzODU1NjYsMC4xNjM2OTQ0NjggOC43MjE0NjIxNywwLjE0MzU3MTk4OCA4LjI5Njg0OTIzLDAuNTE3OTgzNjMyIEw0LjQwOTE2NywzLjgzNzUwNjIgTDcuNzI0OTg5MzIsNy4xNTM1MTkyNiBaIE00LjA1MDE4NTc3LDkuMzkxOTk3MzYgTDUuMDQzNTQ5NjQsOC4zOTg2MzM0OCBMNS44NzgyOTg3OCw4LjY1NDEwMzE1IEM2LjE0NjQ3MTM2LDguNzM2MTM4MDIgNi40Mzc4NzUzOSw4LjY1MzkxMjQyIDYuNjIzNDIxODIsOC40NDM1NTE0NCBMNy4zMTc3NTIyOSw3LjYzMDI3ODk5IEwzLjkzMjIxNjU0LDQuMjQ0NzQzMjQgTDMuMTIxMjkwMTMsNC45MzY5MTg0MSBDMi45ODc4MzMyNiw1LjA1NDcxNTk4IDIuODc5NTE1MTksNS4yOTQ3NzQzMSAyLjg3OTUxNTE5LDUuNDcyNzY3NjYgQzIuODc5NTE1MTksNS41MzE1MzI5MyAyLjg5MzQxOTczLDUuNjI0ODQwMiAyLjkxMDU0NzY4LDUuNjgxMDY4NyBMMy4xNjU0MjYwNyw2LjUxNzU5MTY3IEwyLjE3MDcwNzk4LDcuNTEyNTAwNDkgTDQuMDUwMTg1NzcsOS4zOTE5OTczNiBaIE0yLjYzOTA1NjMyLDEwLjI0OTk5NyBMMy4zMzE0NDEzLDkuNTU3NjEyMDQgTDIuMDIyMDY4NjYsOC4yNDgyMzk0IEwwLjY4NzUsOS42MjQ2MTcwNCBMMi42MzkwNTYzMiwxMC4yNDk5OTcgWiIgaWQ9Iu+WkSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iIzQyNEE1MyIgeD0iMCIgeT0iMTEiIHdpZHRoPSIxMSIgaGVpZ2h0PSIyIj48L3JlY3Q+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlci0yKSIgaWQ9Ikdyb3VwLUNvcHktNSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM3LjAwMDAwMCwgMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJJY29uLS8tQ2hlY2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjAwMDAwMCwgMC4wMDAwMDApIiBmaWxsPSIjNDI0QTUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03LjcyNDk4OTMyLDcuMTUzNTE5MjYgTDExLjA0NDMwMjEsMy4yNjU2NDYzIEMxMS40MTg5MjM1LDIuODQxMDMzMzYgMTEuMzk4ODAxMSwyLjE5ODYzOTg3IDEwLjk5ODQxMTQsMS43OTgyNTAyIEw5Ljc2NDAzNTUyLDAuNTYzODkzNDA0IEM5LjM2Mzg1NTY2LDAuMTYzNjk0NDY4IDguNzIxNDYyMTcsMC4xNDM1NzE5ODggOC4yOTY4NDkyMywwLjUxNzk4MzYzMiBMNC40MDkxNjcsMy44Mzc1MDYyIEw3LjcyNDk4OTMyLDcuMTUzNTE5MjYgWiBNNC4wNTAxODU3Nyw5LjM5MTk5NzM2IEw1LjA0MzU0OTY0LDguMzk4NjMzNDggTDUuODc4Mjk4NzgsOC42NTQxMDMxNSBDNi4xNDY0NzEzNiw4LjczNjEzODAyIDYuNDM3ODc1MzksOC42NTM5MTI0MiA2LjYyMzQyMTgyLDguNDQzNTUxNDQgTDcuMzE3NzUyMjksNy42MzAyNzg5OSBMMy45MzIyMTY1NCw0LjI0NDc0MzI0IEwzLjEyMTI5MDEzLDQuOTM2OTE4NDEgQzIuOTg3ODMzMjYsNS4wNTQ3MTU5OCAyLjg3OTUxNTE5LDUuMjk0Nzc0MzEgMi44Nzk1MTUxOSw1LjQ3Mjc2NzY2IEMyLjg3OTUxNTE5LDUuNTMxNTMyOTMgMi44OTM0MTk3Myw1LjYyNDg0MDIgMi45MTA1NDc2OCw1LjY4MTA2ODcgTDMuMTY1NDI2MDcsNi41MTc1OTE2NyBMMi4xNzA3MDc5OCw3LjUxMjUwMDQ5IEw0LjA1MDE4NTc3LDkuMzkxOTk3MzYgWiBNMi42MzkwNTYzMiwxMC4yNDk5OTcgTDMuMzMxNDQxMyw5LjU1NzYxMjA0IEwyLjAyMjA2ODY2LDguMjQ4MjM5NCBMMC42ODc1LDkuNjI0NjE3MDQgTDIuNjM5MDU2MzIsMTAuMjQ5OTk3IFoiIGlkPSLvlpEiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiM0MjRBNTMiIHg9IjAiIHk9IjExIiB3aWR0aD0iMTEiIGhlaWdodD0iMiI+PC9yZWN0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgICAgIDxnIGZpbHRlcj0idXJsKCNmaWx0ZXItMykiIGlkPSJHcm91cC1Db3B5LTYiPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2OS4wMDAwMDAsIDAuMDAwMDAwKSIgaWQ9Ikljb24tLy1DaGVjayIgZmlsbD0iIzQyNEE1MyI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTcuNzI0OTg5Myw3LjE1MzUxOTI2IEwyMS4wNDQzMDIxLDMuMjY1NjQ2MyBDMjEuNDE4OTIzNSwyLjg0MTAzMzM2IDIxLjM5ODgwMTEsMi4xOTg2Mzk4NyAyMC45OTg0MTE0LDEuNzk4MjUwMiBMMTkuNzY0MDM1NSwwLjU2Mzg5MzQwNCBDMTkuMzYzODU1NywwLjE2MzY5NDQ2OCAxOC43MjE0NjIyLDAuMTQzNTcxOTg4IDE4LjI5Njg0OTIsMC41MTc5ODM2MzIgTDE0LjQwOTE2NywzLjgzNzUwNjIgTDE3LjcyNDk4OTMsNy4xNTM1MTkyNiBaIE0xNC4wNTAxODU4LDkuMzkxOTk3MzYgTDE1LjA0MzU0OTYsOC4zOTg2MzM0OCBMMTUuODc4Mjk4OCw4LjY1NDEwMzE1IEMxNi4xNDY0NzE0LDguNzM2MTM4MDIgMTYuNDM3ODc1NCw4LjY1MzkxMjQyIDE2LjYyMzQyMTgsOC40NDM1NTE0NCBMMTcuMzE3NzUyMyw3LjYzMDI3ODk5IEwxMy45MzIyMTY1LDQuMjQ0NzQzMjQgTDEzLjEyMTI5MDEsNC45MzY5MTg0MSBDMTIuOTg3ODMzMyw1LjA1NDcxNTk4IDEyLjg3OTUxNTIsNS4yOTQ3NzQzMSAxMi44Nzk1MTUyLDUuNDcyNzY3NjYgQzEyLjg3OTUxNTIsNS41MzE1MzI5MyAxMi44OTM0MTk3LDUuNjI0ODQwMiAxMi45MTA1NDc3LDUuNjgxMDY4NyBMMTMuMTY1NDI2MSw2LjUxNzU5MTY3IEwxMi4xNzA3MDgsNy41MTI1MDA0OSBMMTQuMDUwMTg1OCw5LjM5MTk5NzM2IFogTTEyLjYzOTA1NjMsMTAuMjQ5OTk3IEwxMy4zMzE0NDEzLDkuNTU3NjEyMDQgTDEyLjAyMjA2ODcsOC4yNDgyMzk0IEwxMC42ODc1LDkuNjI0NjE3MDQgTDEyLjYzOTA1NjMsMTAuMjQ5OTk3IFoiIGlkPSLvlpEiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgeD0iMCIgeT0iMTEiIHdpZHRoPSIxMSIgaGVpZ2h0PSIyIj48L3JlY3Q+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlci00KSIgaWQ9Ikdyb3VwLUNvcHktNyI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMS4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iSWNvbi0vLUNoZWNrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMC4wMDAwMDAsIDAuMDAwMDAwKSIgZmlsbD0iIzQyNEE1MyIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNy43MjQ5ODkzMiw3LjE1MzUxOTI2IEwxMS4wNDQzMDIxLDMuMjY1NjQ2MyBDMTEuNDE4OTIzNSwyLjg0MTAzMzM2IDExLjM5ODgwMTEsMi4xOTg2Mzk4NyAxMC45OTg0MTE0LDEuNzk4MjUwMiBMOS43NjQwMzU1MiwwLjU2Mzg5MzQwNCBDOS4zNjM4NTU2NiwwLjE2MzY5NDQ2OCA4LjcyMTQ2MjE3LDAuMTQzNTcxOTg4IDguMjk2ODQ5MjMsMC41MTc5ODM2MzIgTDQuNDA5MTY3LDMuODM3NTA2MiBMNy43MjQ5ODkzMiw3LjE1MzUxOTI2IFogTTQuMDUwMTg1NzcsOS4zOTE5OTczNiBMNS4wNDM1NDk2NCw4LjM5ODYzMzQ4IEw1Ljg3ODI5ODc4LDguNjU0MTAzMTUgQzYuMTQ2NDcxMzYsOC43MzYxMzgwMiA2LjQzNzg3NTM5LDguNjUzOTEyNDIgNi42MjM0MjE4Miw4LjQ0MzU1MTQ0IEw3LjMxNzc1MjI5LDcuNjMwMjc4OTkgTDMuOTMyMjE2NTQsNC4yNDQ3NDMyNCBMMy4xMjEyOTAxMyw0LjkzNjkxODQxIEMyLjk4NzgzMzI2LDUuMDU0NzE1OTggMi44Nzk1MTUxOSw1LjI5NDc3NDMxIDIuODc5NTE1MTksNS40NzI3Njc2NiBDMi44Nzk1MTUxOSw1LjUzMTUzMjkzIDIuODkzNDE5NzMsNS42MjQ4NDAyIDIuOTEwNTQ3NjgsNS42ODEwNjg3IEwzLjE2NTQyNjA3LDYuNTE3NTkxNjcgTDIuMTcwNzA3OTgsNy41MTI1MDA0OSBMNC4wNTAxODU3Nyw5LjM5MTk5NzM2IFogTTIuNjM5MDU2MzIsMTAuMjQ5OTk3IEwzLjMzMTQ0MTMsOS41NTc2MTIwNCBMMi4wMjIwNjg2Niw4LjI0ODIzOTQgTDAuNjg3NSw5LjYyNDYxNzA0IEwyLjYzOTA1NjMyLDEwLjI0OTk5NyBaIiBpZD0i75aRIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjNDI0QTUzIiB4PSIwIiB5PSIxMSIgd2lkdGg9IjExIiBoZWlnaHQ9IjIiPjwvcmVjdD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgICAgICA8ZyBmaWx0ZXI9InVybCgjZmlsdGVyLTUpIiBpZD0iR3JvdXAtQ29weS04Ij4KICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMzLjAwMDAwMCwgMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJJY29uLS8tQ2hlY2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjAwMDAwMCwgMC4wMDAwMDApIiBmaWxsPSIjNDI0QTUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03LjcyNDk4OTMyLDcuMTUzNTE5MjYgTDExLjA0NDMwMjEsMy4yNjU2NDYzIEMxMS40MTg5MjM1LDIuODQxMDMzMzYgMTEuMzk4ODAxMSwyLjE5ODYzOTg3IDEwLjk5ODQxMTQsMS43OTgyNTAyIEw5Ljc2NDAzNTUyLDAuNTYzODkzNDA0IEM5LjM2Mzg1NTY2LDAuMTYzNjk0NDY4IDguNzIxNDYyMTcsMC4xNDM1NzE5ODggOC4yOTY4NDkyMywwLjUxNzk4MzYzMiBMNC40MDkxNjcsMy44Mzc1MDYyIEw3LjcyNDk4OTMyLDcuMTUzNTE5MjYgWiBNNC4wNTAxODU3Nyw5LjM5MTk5NzM2IEw1LjA0MzU0OTY0LDguMzk4NjMzNDggTDUuODc4Mjk4NzgsOC42NTQxMDMxNSBDNi4xNDY0NzEzNiw4LjczNjEzODAyIDYuNDM3ODc1MzksOC42NTM5MTI0MiA2LjYyMzQyMTgyLDguNDQzNTUxNDQgTDcuMzE3NzUyMjksNy42MzAyNzg5OSBMMy45MzIyMTY1NCw0LjI0NDc0MzI0IEwzLjEyMTI5MDEzLDQuOTM2OTE4NDEgQzIuOTg3ODMzMjYsNS4wNTQ3MTU5OCAyLjg3OTUxNTE5LDUuMjk0Nzc0MzEgMi44Nzk1MTUxOSw1LjQ3Mjc2NzY2IEMyLjg3OTUxNTE5LDUuNTMxNTMyOTMgMi44OTM0MTk3Myw1LjYyNDg0MDIgMi45MTA1NDc2OCw1LjY4MTA2ODcgTDMuMTY1NDI2MDcsNi41MTc1OTE2NyBMMi4xNzA3MDc5OCw3LjUxMjUwMDQ5IEw0LjA1MDE4NTc3LDkuMzkxOTk3MzYgWiBNMi42MzkwNTYzMiwxMC4yNDk5OTcgTDMuMzMxNDQxMyw5LjU1NzYxMjA0IEwyLjAyMjA2ODY2LDguMjQ4MjM5NCBMMC42ODc1LDkuNjI0NjE3MDQgTDIuNjM5MDU2MzIsMTAuMjQ5OTk3IFoiIGlkPSLvlpEiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiM0MjRBNTMiIHg9IjAiIHk9IjExIiB3aWR0aD0iMTEiIGhlaWdodD0iMiI+PC9yZWN0PgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/**
 *
 * @param {string} currentResponse
 * @returns import("../shared-types").TeacherResponse
 */
const InitialTeacherResponse = (currentResponse) => {
  let response = {
    drawing_feedback: undefined,
    essay_annotation: {
      current: true,
      annotated_essay: currentResponse,
      comments: []
    }
  }
  return response;
}

/**
 * @type number | null
 */
const initialSelectedCommentId = null;

/**
 * @param {{
 *   response: string,
 *   readOnly: boolean,
 *   teacherResponse: import("../../shared-types").TeacherResponse | undefined,
 *   teacherResponseDidChange: function,
 *   teacherResponseDidFinishEdit: function,
 * }} props
 */

export default function EssayAnnotationEditor(props) {
  let [selectedCommentId, setSelectedCommentId] = useState(initialSelectedCommentId);
  let [highlightEditor, _] = useState(new HighlightEditor( {
    onHighlightSelection: (id) => {
      setSelectedCommentId(id);
    }
  }));
  let [commentsHidden, setCommentsHidden] = useState(false);
  let [teacherResponse, setTeacherResponse] = useState(props.teacherResponse?.essay_annotation?.current ? props.teacherResponse : InitialTeacherResponse(props.response) )
  let [hasSelection, setHasSelection] = useState(false);
  let studentResponseChanged = props.teacherResponse?.essay_annotation && !props.teacherResponse.essay_annotation?.current;

  let responseChangedMessage = "The student has changed this response. Previously made comments are no longer available.";
  if(props.readOnly) {
    responseChangedMessage = "You have made changes to your response.  The comments previously made by your teacher are no longer available.";
  }

  let commentChanged = (comment) => (message) => {
    if(unEditedCommentIds.includes(comment.id)) {
      setUnEditedCommentIds(unEditedCommentIds.filter((id) => id !== comment.id))
    }

    if(!teacherResponse.essay_annotation) {
      return
    }

    let updatedTeacherResponse = {
      ...teacherResponse, essay_annotation: {
        ...teacherResponse.essay_annotation, comments: teacherResponse.essay_annotation.comments.map((c) => {
          if(c.id == comment.id) {
            return {...comment, message: message}
          } else {
            return c
          }
        })
      }
    };

    setTeacherResponse(updatedTeacherResponse);
    props.teacherResponseDidFinishEdit(updatedTeacherResponse);
  }
  let commentDeleted = (comment) => () => {
    if(!teacherResponse.essay_annotation) {
      return
    }

    highlightEditor.deleteSelectionById(comment.id);
    let annotatedEssay = highlightEditor.getCurrentMarkup();

    let updatedTeacherResponse = {
      ...teacherResponse, essay_annotation: {
        ...teacherResponse.essay_annotation, annotated_essay: annotatedEssay, comments: teacherResponse.essay_annotation.comments.filter((c) => {
          return c.id !== comment.id
        })
      }
    };

    setTeacherResponse(updatedTeacherResponse);
    props.teacherResponseDidFinishEdit(updatedTeacherResponse);
  }

  useEffect(() => {
    let selectionChangeCallback =  () => {
      if(highlightEditor.selectionIsInBounds()) {
        setHasSelection(true)
      } else {
        setHasSelection(false)
      };
    };

    document.addEventListener("selectionchange", selectionChangeCallback);

    return function cleanup() {
      document.removeEventListener("selectionchange", selectionChangeCallback);
    };
  }, [])

  /**
   * @type number[]
   */
  let initialUnEditedCommentIds = [];
  let [unEditedCommentIds, setUnEditedCommentIds] = useState(initialUnEditedCommentIds);

  let nextId = 0;
  teacherResponse.essay_annotation?.comments.forEach((comment) => {
    if(comment.id >= nextId) {
      nextId = comment.id + 1;
    }
  })

  let toolbar = <Toolbar
    toggleCommentsHidden={() => {
      highlightEditor.hideHighlights(!commentsHidden)
      setCommentsHidden(!commentsHidden)
    }}
    showToggleCommentsButton={teacherResponse.essay_annotation !== undefined && teacherResponse.essay_annotation.comments.length > 0}
    commentsHidden={commentsHidden}
    disableCommentButton={!hasSelection || commentsHidden}
    addComment={(color) => {
      if(!teacherResponse.essay_annotation) {
        return
      }

      try {
        highlightEditor.highlightSelection(nextId, color);
      } catch(e) {
        console.log(e)
        return;
      }
      setUnEditedCommentIds([...unEditedCommentIds, nextId]);

      let commentIndex = highlightEditor.getOrderedHighlightIds().indexOf(nextId);
      let annotatedEssay = highlightEditor.getCurrentMarkup();

      let originalComments = teacherResponse.essay_annotation.comments;
      let comments = [...originalComments.slice(0, commentIndex), {message: "", color: color, id: nextId}, ...originalComments.slice(commentIndex)]
      setTeacherResponse({
        ...teacherResponse, essay_annotation: {
          ...teacherResponse.essay_annotation, annotated_essay: annotatedEssay, comments: comments
      }})

      setSelectedCommentId(nextId);

      props.teacherResponseDidChange();
    }}/>;

  return (
    <div className={`response-collector is-adding-comments ${props.readOnly ? "readonly" : ""}`}>
      {studentResponseChanged && <div className="message-info">{responseChangedMessage}</div>}
      {(!props.readOnly || !studentResponseChanged) && toolbar}

      <div className="highlighter-response-comments">
        <HighlightEditorWrapper
          response={teacherResponse.essay_annotation?.annotated_essay}
          highlightEditor={highlightEditor}
          nextId={nextId}>
        </HighlightEditorWrapper>
        <CommentList
          comments={teacherResponse.essay_annotation?.comments || []}
          unEditedCommentIds={unEditedCommentIds}
          selectedCommentId={selectedCommentId}
          onSelect={(id) => {
            setSelectedCommentId(id);
            highlightEditor.setSelectedHighlightId(id);
            if(id !== null) {
              highlightEditor.scrollToHighlight(id);
            }
          }}
          commentChanged={commentChanged}
          commentDeleted={commentDeleted}/>
      </div>
    </div>
  );
}

class HighlightEditorWrapper extends Component {
  shouldComponentUpdate() {
    return false
  }

  componentDidMount() {
    this.props.highlightEditor.setRootElement(this.el)
  }

  render() {
    return <div ref={el => this.el = el} className="essay-response reset-to-browser-defaults" dangerouslySetInnerHTML={{__html: this.props.response}}></div>
  }
}

/**
 *
 * @param {{
 * comments: import("../../shared-types").Comment[],
 * unEditedCommentIds: number[],
 * selectedCommentId: number | null,
 * onSelect: function(number | null): void,
 * commentChanged: function(import("../../shared-types").Comment): function(string): void,
 * commentDeleted: function(import("../../shared-types").Comment): function(number): void
 * }} props
 */
function CommentList(props) {
  if(props.comments.length) {
    return <div className="highlighter-comments rounded-corners-md">
      {props.comments.map((comment) => {
        return <Fragment key={String(comment.id)}>
          <Comment
            isNew={props.unEditedCommentIds.includes(comment.id)}
            isSelected={comment.id == props.selectedCommentId}
            message={comment.message}
            id={comment.id}
            color={comment.color}
            onSelect={props.onSelect}
            onChange={props.commentChanged(comment)}
            onDelete={props.commentDeleted(comment)}
          ></Comment>
        </Fragment>
      })}
    </div>
  } else {
    return null;
  }
}

/**
 * @param {{
 *  onEdit: function(this: HTMLDivElement, h.JSX.TargetedEvent<HTMLDivElement, MouseEvent>): void,
 *  onDelete: function(this: HTMLDivElement, h.JSX.TargetedEvent<HTMLDivElement, MouseEvent>): void
 * }} props
 */
var CommentOptionsDropdown = (props) => {
  let [isOpen, setIsOpen] = useState(false);

  /**
   * @type import("preact").RefObject.<HTMLButtonElement>
   */
  let button = useRef(null)
  useEffect(() => {
    let clickHandler = (e) => {
      if(button.current && !button.current.contains(e.target)) {
        setIsOpen(false)
      }
    };

    function cleanup() {
      document.removeEventListener("mouseup", clickHandler);
      document.removeEventListener("touchup", clickHandler);
    }

    if(isOpen) {
      document.addEventListener("mouseup", clickHandler);
      document.addEventListener("touchup", clickHandler);
    } else {
      cleanup();
    }

    return cleanup
  }, [isOpen])
  return (
    <button
      ref={button}
      onClick={() => {
        setIsOpen(!isOpen);
      }}
      className={
        "button-icon-only highlighter-comment-options-button " +
        (isOpen ? "is-open" : "")
      }

      type="button"
      tabIndex={-1}
    >
      <img src={DOTS}/>
      <div className="highlighter-comment-options rounded-corners-md padding-md box-shadow-lg">
        <div className="padding-md hover padding-md rounded-corners-md color-text" onClick={props.onEdit}>
          Edit
        </div>
        <div className="padding-md hover padding-md rounded-corners-md color-text" onClick={props.onDelete}>
          Delete
        </div>
      </div>
    </button>
  );
};

const HighlightColors = [
  "purple-highlight",
  "blue-highlight",
  "green-highlight",
  "yellow-highlight",
  "red-highlight"
];

/**
 *
 * @param {{
 *  didSelectColor: function(string): void,
 *  currentColor: string,
 *  disabled: boolean
 * }} props
 */
var ColorPicker = (props) => {
  let [isOpen, setIsOpen] = useState(false);
  /**
   * @type import("preact").RefObject.<HTMLButtonElement>
   */
  let button = useRef(null)
  useEffect(() => {
    let clickHandler = (e) => {
      if(isOpen && button.current && !button.current.contains(e.target)) {
        setIsOpen(false)
      }
    };

    function cleanup() {
      document.removeEventListener("mouseup", clickHandler);
      document.removeEventListener("touchup", clickHandler);
    }

    if(isOpen) {
      document.addEventListener("mouseup", clickHandler);
      document.addEventListener("touchup", clickHandler);
    } else {
      cleanup();
    }

    return cleanup;
  }, [isOpen])
  return (
    <div class="color-picker">
      <button
        ref={button}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        class="color-picker"
        type="button"
        disabled={props.disabled}
      >
        <span
          class={`color-picker-current-color rounded-corners-sm ${props.currentColor}`}
        ></span>
        <div
          class="color-picker-palette bottom-right padding-md rounded-corners-md"
          style={{ display: isOpen ? "flex" : "none" }}
        >
          {HighlightColors.map((color) => {
            return (
              <span
                class={`color-picker-color rounded-corners-md ${color}`}
                onClick={() => {
                  props.didSelectColor(color);
                }}
              ></span>
            );
          })}
        </div>
      </button>
    </div>
  );
};

/**
 * @param {{
 *  disableButtons: boolean,
 *  addComment: function(string): void,
 * }} props
 */
var CommentButtons = (props) => {
  let buttons = [];
  let styles = {
    backgroundImage: `url("${MARKERS}")`
  }
  HighlightColors.forEach((color) => {
    let fn = () => {return props.addComment(color)};
    buttons.push(<button type="button" class="color-picker-inline-button add-comment" onClick={fn} disabled={props.disableButtons}>
      <span style={styles} class={`color-picker-inline-color ${color}`}></span>
    </button>);
  });
  return (
    <div class="color-picker-inline">{buttons}</div>
  )
}

/**
 * @param {{
 *  toggleCommentsHidden: function,
 *  showToggleCommentsButton: boolean,
 *  commentsHidden: boolean,
 *  disableCommentButton: boolean,
 *  addComment: function(string): void,
 * }} props
 */
var Toolbar = (props) => {
  return (
    <div className="highlighter-toolbar">
      <CommentButtons
        addComment={props.addComment}
        disableButtons={props.disableCommentButton}
      ></CommentButtons>
      <button
        style={ props.showToggleCommentsButton ? {} : {display: "none"}}
        type="button"
        className="toggle-comments"
        onClick={() => {
          props.toggleCommentsHidden();
        }}
        tabIndex={-1}
      >
        {props.commentsHidden ? "Show Highlights" : "Hide Highlights"}
      </button>
      <span class="message">
        Select text or equations to highlight then click your preferred color to
        add comments.{" "}
      </span>
    </div>
  );
};

/**
 *
 * @param {{
 *   isNew: boolean,
 *   isSelected: boolean,
 *   message: string,
 *   id: number,
 *   color: string,
 *   onChange: function(string): void,
 *   onDelete: function(number): void,
 *   onSelect: function(number | null): void
 * }} props
 */
var Comment = (props) => {
  let content;
  let [message, setMessage] = useState(props.message);
  let [editing, setEditing] = useState(props.isNew);
  /**
   * @type import("preact").RefObject.<HTMLTextAreaElement>
   */
  let textareaRef = useRef(null);
  useEffect(() => {
    if(props.isNew && textareaRef.current && textareaRef.current !== document.activeElement) {
      textareaRef.current.focus();
    }
  }, [textareaRef, props.isNew])

  useEffect(() => {
    if(props.isSelected  && commentElementRef.current) {
      commentElementRef.current.closest(".highlighter-comments")?.scrollTo(0, commentElementRef.current.offsetTop - 16)
    }
  }, [props.isSelected])

  /**
   * @type import("preact").RefObject.<HTMLDivElement>
   */
  let commentElementRef = useRef(null);
  useEffect(() => {
    /**
     *
     * @param {Event} e
     */
    let clickHandler = (e) => {
      if(commentElementRef.current
        && e.target instanceof HTMLElement
        && !commentElementRef.current.contains(e.target)
        && !e.target.closest(".comment-highlight")
      ) {
        props.onSelect(null)
      }
    };

    function cleanup() {
      document.removeEventListener("mouseup", clickHandler);
      document.removeEventListener("touchup", clickHandler);
    }

    if(props.isSelected) {
      document.addEventListener("mouseup", clickHandler);
      document.addEventListener("touchup", clickHandler);
    } else {
      cleanup();
    }

    return cleanup
  }, [commentElementRef, props.isSelected])

  let dropdown = <CommentOptionsDropdown onEdit={() => {
    setEditing(true)
  }} onDelete={() => {
    props.onDelete(props.id)
  }}></CommentOptionsDropdown>
  if (!editing) {
    content = (
      <>
        <div class="comment-readonly">
          {props.message}
          {dropdown}
        </div>
      </>
    );
  } else {
    content = (
      <>
        <textarea
          ref={textareaRef}
          class="text-area rounded-corners-md color-text"
          id="highlighter-comment-id"
          name="highlighter-comment-name"
          onChange={
            (e) => {
              if(e.target instanceof HTMLTextAreaElement) {
                setMessage(e.target.value)
              }
            }
          }
          autocomplete="on"
        >
          {props.message}
        </textarea>
        {dropdown}
        <button type="button" className="button-primary" onClick={() => {props.onChange(message); setEditing(false)}}>Done</button>
      </>
    );
  }

  return (
    <div
      ref={commentElementRef}
      className={`highlighter-comment rounded-corners-md color-text ${props.isSelected ? 'selected' : ''} ${props.color}`}
      onClick={(e) => {
        props.onSelect(props.id)
      }}>
      {content}
    </div>
  );
};
